<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >PARTS RECOMMEND
        </v-alert>
        <v-alert>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-select
                                :items="category"
                                item-text="category_name"
                                item-value="category_id"
                                label="Category"
                                v-model="information.category_id"
                                dense
                                outlined
                                menu-props="auto"
                                @change="getPart()"
                            ></v-select>
                            <v-autocomplete
                                :items="part"
                                :item-text="text"
                                item-value="part_id"
                                label="Part"
                                v-model="information.part_id"
                                dense
                                outlined
                                menu-props="auto"
                            ></v-autocomplete>
                            <v-text-field
                                v-model="information.partremark"
                                label="Remark"
                            ></v-text-field>
                            <v-btn
                                :disabled="
                                    information.category_id != undefined &&
                                    information.category_id != '' &&
                                    information.part_id != undefined &&
                                    information.part_id != ''
                                        ? false
                                        : true
                                "
                                class="ma-2"
                                @click="addpart()"
                                tile
                                color="teal"
                                >Recommend part</v-btn
                            >
                        </v-col>
                        <v-col cols="12" sm="6" md="8">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                Part Detail
                                            </th>
                                            <th>Status / Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in partShow"
                                            :key="item.id"
                                        >
                                            <td>
                                                {{ item.PartNo }}
                                                <p v-if="item.PartRemark">
                                                    ## {{ item.PartRemark }}
                                                </p>
                                            </td>
                                            <td v-if="item.part_issue_id == ''">
                                                <div class="my-2">
                                                    <v-btn
                                                        @click="delpart(index)"
                                                        color="danger"
                                                        fab
                                                        small
                                                        dark
                                                    >
                                                        <v-icon
                                                            >mdi-delete</v-icon
                                                        >
                                                    </v-btn>
                                                </div>
                                            </td>
                                            <td
                                                v-else-if="
                                                    item.oldstatus ==
                                                        'Recommended' ||
                                                        item.oldstatus ==
                                                            'Back Order'
                                                "
                                            >
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="6"
                                                    >
                                                        <v-select
                                                            :items="stapart"
                                                            v-model="
                                                                item.status
                                                            "
                                                            @change="
                                                                updatestatus(
                                                                    index
                                                                )
                                                            "
                                                            label="Status"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col
                                                        v-if="
                                                            team_name ==
                                                                'INVENTORY'
                                                        "
                                                        cols="12"
                                                        sm="6"
                                                        md="6"
                                                    >
                                                        <v-checkbox
                                                            dense
                                                            label="Use part from vendor ?"
                                                            true-value="Y"
                                                            false-value="N"
                                                            v-model="
                                                                item.vendor
                                                            "
                                                            @change="
                                                                updatevendor(
                                                                    index
                                                                )
                                                            "
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-alert>
    </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"

export default {
    props: ["information", "condition"],
    created() {
        if (this.condition.status == "editcase") {
            _.delay(this.getCategory, 2000)
            _.delay(this.getPartEdit, 2000)
        } else if (this.condition.status == "subcase") {
            // _.delay(this.getCategory, 2000);
            _.delay(this.getPartEdit, 2000)
        }
    },
    watch: {
        // whenever question changes, this function will run
        information: function(newQuestion, oldQuestion) {
            this.getCategory()
        },
    },

    mounted() {
        // if (this.information.project_id !== undefined) {
        //     this.getCategory()
        // }
        if (this.information.project_id == undefined) {
            this.information.project_id = 136
            this.information.problem_group_id = 4
        }
        this.getCategory()
    },
    data() {
        return {
            category: [],
            part: [],
            partShow: [],
            partItems: {},
            partSelected: {},
            partShowSelected: [],
            counter: 1,
            stapart: ["Recommended", "Cancel"],
            team_name: localStorage.team_name,
        }
    },
    methods: {
        text: (item) => item.part_name + " — " + item.part_description,
        async getCategory() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/newcase/${this.information.project_id}/${this.information.problem_group_id}`
            console.log(url)
            try {
                const { data } = await axios.get(`${url}`)
                console.log(data)
                this.category = data.categories
                this.information.problem_type = data.problem_type
                this.information.is_special = data.is_special
                console.log(this.category)
            } catch (error) {
                console.log(error)
            }
        },
        getPart() {
            this.category.map((each) => {
                if (each.category_id == this.information.category_id) {
                    this.part = [...each.partno]
                }
            })
        },
        addpart() {
            this.part.map((each) => {
                if (each.part_id == this.information.part_id) {
                    this.partItems.PartNo = each.part_name
                }
            })

            this.partSelected.part_id = this.information.part_id
            this.partSelected.part_remark = this.information.partremark
            this.partSelected.part_issue_id = ""
            this.partSelected.status = "Recommended"

            this.partItems.PartRemark = this.information.partremark
            this.partItems.part_issue_id = ""
            this.partItems.status = "Recommended"
            this.partShow.push({ ...this.partItems })
            this.partShowSelected.push({ ...this.partSelected })

            this.information.part = [...this.partShowSelected]
        },
        delpart(index) {
            this.partShow.splice(index, 1)
            this.partShowSelected.splice(index, 1)
            this.updatePart()
        },
        updatestatus(index) {
            let value = this.partShow[index].status
            this.partShowSelected[index].status = value
            this.updatePart()
        },
        updatevendor(index) {
            let value = this.partShow[index].vendor
            this.partShowSelected[index].vendor = value
            this.updatePart()
        },
        updatePart() {
            this.information.part = [...this.partShowSelected]
        },
        getPartEdit() {
            this.information.parts.map((each) => {
                this.partShow.push({
                    PartNo: each.part_name + " " + each.part_description,
                    PartRemark: each.remark,
                    part_issue_id: each.part_issue_id,
                    status: each.status,
                    oldstatus: each.status,
                    vendor: each.vendor == null ? "N" : each.vendor,
                })
                this.partShowSelected.push({
                    part_id: each.recommend_part_id,
                    part_remark: each.remark,
                    part_issue_id: each.part_issue_id,
                    status: each.status,
                    oldstatus: each.status,
                    vendor: each.vendor == null ? "N" : each.vendor,
                })
            })

            this.updatePart()
        },
    },
}
</script>
